module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.$props.tagname, {
    tag: "section",
    staticClass: "ps-container",
    on: {
      "~mouseover": function($event) {
        _vm.update($event)
      },
      "ps-scroll-y": _vm.scrollHanle,
      "ps-scroll-x": _vm.scrollHanle,
      "ps-scroll-up": _vm.scrollHanle,
      "ps-scroll-down": _vm.scrollHanle,
      "ps-scroll-left": _vm.scrollHanle,
      "ps-scroll-right": _vm.scrollHanle,
      "ps-y-reach-start": _vm.scrollHanle,
      "ps-y-reach-end": _vm.scrollHanle,
      "ps-x-reach-start": _vm.scrollHanle,
      "ps-x-reach-end": _vm.scrollHanle
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44138184!./~/vue-loader/lib/selector.js?type=template&index=0!./index.vue
// module id = 26
// module chunks = 0